import { gql } from 'graphql-request'

export const USUARIO_DOMINIO_QUERY = gql`
  query usuarioDominioQuery {
    produtos {
      id
      nome
      tiposAcesso {
        id
        nome
        funcionalidadesPadrao {
          id
        }
      }
    }
    idiomas {
      id
      description
    }
    grupos {
      id
      nome
      marcas {
        id
        description
      }
    }
    dealers {
      id
      nomeExibicao
      active
      grupo {
        id
      }
    }
    funcionalidades {
      id
      descricao
    }
    marcas {
      id
      description
    }
    tiposUsuario {
      id
      description
    }
  }
`
